// ✅ STOK GÜNCELLEME FONKSİYONU - VARIABLE VE SIMPLE ÜRÜNLER İÇİN
function updateStock(variationId = 0, productId = 0) {
    console.log('updateStock çağrıldı | variationId:', variationId, '| productId:', productId);
    
    const stockElement = document.getElementById('product-stock-info');
    if (!stockElement) {
        console.warn('Stok elementi bulunamadı.');
        return;
    }

    // HTML üzerindeki data niteliklerinden dinamik WordPress verilerini okuyoruz
    const ajaxUrl = stockElement.getAttribute('data-ajax-url');
    const nonce = stockElement.getAttribute('data-nonce');

    if (!ajaxUrl || !nonce) {
        console.error('AJAX URL veya Nonce değeri element üzerinde bulunamadı.');
        return;
    }
    
    // AJAX çağrısı
    fetch(ajaxUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            'action': 'get_variation_stock',
            'variation_id': variationId || 0,
            'product_id': productId || 0,
            'nonce': nonce
        })
    })
    .then(response => {
        console.log('Yanıt durumu:', response.status);
        return response.json();
    })
    .then(data => {
        console.log('AJAX yanıtı:', data);
        
        if (data.success && data.data) {
            const addBtn = document.getElementById('add-to-cart-btn');
            
            // Eski classları temizle
            stockElement.classList.remove('bg-red-100', 'text-red-600', 'bg-yellow-100', 'text-yellow-600', 'bg-green-100', 'text-green-600');
            
            const stock = data.data.stock || 0;
            const isInStock = data.data.is_in_stock;
            
            console.log('Stok güncellemesi | Stock:', stock, '| İnStock:', isInStock);
            
            // Yeni classları ekle
            if (!isInStock) {
                stockElement.classList.add('bg-red-100', 'text-red-600');
                stockElement.innerHTML = '<span class="w-2 h-2 bg-red-600 rounded-full animate-pulse"></span><span class="status-text">Brak w Magazynie</span>';
            } else if (stock <= 5 && stock > 0) {
                stockElement.classList.add('bg-yellow-100', 'text-yellow-600');
                stockElement.innerHTML = '<span class="w-2 h-2 bg-yellow-600 rounded-full animate-pulse"></span><span class="status-text">Niski Stan Magazynowy (' + stock + ')</span>';
            } else {
                stockElement.classList.add('bg-green-100', 'text-green-600');
                stockElement.innerHTML = '<span class="w-2 h-2 bg-green-600 rounded-full animate-pulse"></span><span class="status-text">W Magazynie</span>';
            }
            
            // Data atributlarını güncelle
            stockElement.setAttribute('data-stock', stock);
            stockElement.setAttribute('data-in-stock', isInStock ? '1' : '0');
            
            // ✅ ADD TO CART BUTON DURUMUNU GÜNCELLE
            if (addBtn) {
                if (data.data.is_in_stock) {
                    addBtn.disabled = false;
                    addBtn.classList.remove('opacity-50', 'cursor-not-allowed');
                    addBtn.textContent = 'Dodaj Do Koszyka';
                } else {
                    addBtn.disabled = true;
                    addBtn.classList.add('opacity-50', 'cursor-not-allowed');
                    addBtn.textContent = 'Brak w Magazynie';
                }
            }
        } else {
            console.error('AJAX başarısız:', data.message || 'Bilinmeyen hata');
        }
    })
    .catch(err => {
        console.error('Stok güncelleme hatası:', err);
    });
}

// Fonksiyonu tarayıcı genelinde (global scope) erişilebilir kılmak için window nesnesine bağlıyoruz.
window.updateStock = updateStock;